<span class="d-inline-block text-logo-blue cursor-pointer text-underline lH-12">
    {{name}}
</span>
<span class="ml-2 preapproval-badge" *ngIf="preApprovalId > 0">
   {{tagName}}
</span>


